<xlog-omni-loader [hide]="loaded"></xlog-omni-loader>